"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fabric_1 = require("fabric");
const replaceXPositionWithTextAnchorMiddle = (markup) => {
    const positionRegex = /<tspan\sx=".[0-9]*.[0-9]*"\sy=".[0-9]*.[0-9]*"\s>\*\|/g;
    const xPositionRegex = /<tspan\sx=".[0-9]*.[0-9]*"/;
    const textAnchorMiddle = '<tspan text-anchor="middle"';
    return markup.replace(positionRegex, (item) => item.replace(xPositionRegex, textAnchorMiddle));
};
fabric_1.fabric.IText.prototype.toSVG = (function overrideToSVG(toSVG) {
    return function toSVGForceTextAnchorMiddle() {
        const originalSVG = toSVG.call(this);
        return this.textAlign === 'center'
            ? replaceXPositionWithTextAnchorMiddle(originalSVG)
            : originalSVG;
    };
})(fabric_1.fabric.IText.prototype.toSVG);
